// Lib
import React from 'react';

// Utils
import { canSave } from '../../../../common/permissions/permissionUtil';

// Components
import SavingFeedbackUtil from './savingFeedback/SavingFeedbackUtil';

// Styles
import './CurrentBoardHeaderStatus.scss';

type CurrentBoardHeaderStatusProps = {
    permissions: number;
};

const CurrentBoardHeaderStatus: React.FC<CurrentBoardHeaderStatusProps> = ({ permissions }) => {
    if (canSave(permissions)) return <SavingFeedbackUtil />;

    return null;
};

export default CurrentBoardHeaderStatus;
